import { Thumbnails } from '../../components/Thumbnails';
import { useGallery } from '../../hooks';

export function ThumbnailsContainer() {
  const { thumbnails, photos } = useGallery();

  if (thumbnails === null) {
    return null;
  }

  return <Thumbnails media={thumbnails} hasMore={photos.length > 4} />;
}
